import React from "react";
import PropTypes from "prop-types";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";

export default function ViewNotificationList(props) {
  const { notificationList } = props;
  return (
    <>
      <CustomInput
        labelText="Name"
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          disabled: true,
          value: notificationList.name
        }}
      />
    </>
  );
}

ViewNotificationList.propTypes = {
  notificationList: PropTypes.object
};
